module.exports = __webpack_require__.p + "74eb163e7d00a1077e233b56084ced3e.jpg";